import type { Locale } from '@change-corgi/config/locales';
import type { Utilities } from '@change-corgi/core-react/utilityContext';

import {
	SharedTopicPageLocale,
	type SharedTopicPageLocaleQuery,
	type SharedTopicPageLocaleQueryVariables,
} from './topicPageLocale.graphql';

export async function getTopicPageLocale(
	slug: string,
	utilities: Pick<Utilities, 'gql' | 'http'>,
): Promise<Locale | undefined> {
	const { data } = await utilities.gql.fetch<SharedTopicPageLocaleQuery, SharedTopicPageLocaleQueryVariables>({
		query: SharedTopicPageLocale,
		variables: { slug },
		rejectOnError: true,
	});

	return data.topicPage?.locale.localeCode;
}
